export function Icon({ name, className = '' }) {
  return (
    <span
      className={`custom-icon ${className}`.trim()}
      style={{ '--icon-source': `url('/icons/${name}.webp')` }}
      aria-hidden="true"
    />
  );
}
